import React, { useState, useRef, useEffect } from 'react';

import "./MultiSelekt.scss";
import "./../UIElements/OptionChip";
import OptionChip from './../UIElements/OptionChip';

const MultiSelekt = (props) => {
const [open, setOpen] = useState(false);
const [query, setQuery] = useState("");
const [selectedItems, setSelectedItems] = useState([]);
const ref = useRef(null);

useEffect(() => {
    ["click", "touchend"].forEach(e => {
        document.addEventListener(e, toggleSourcePanel);
    })
return () =>  ["click", "touchend"].forEach(e => {
    document.removeEventListener(e, toggleSourcePanel);
});
}, []);

useEffect(() => {
    props.onChange(selectedItems);
}
,[selectedItems]);

function toggleSourcePanel(e) {
    setOpen(e && e.target === ref.current);
}

function filter(options){
return options.filter((option) => 
    option[props.optionLabel].toLowerCase().indexOf(query.toLowerCase()) > -1);
}

function displayPrompt() {
    if(query.length > 0) return query
    /*if(props.value) return props.value[props.optionLabel];*/
    return props.prompt;
};

const selectOptionHandler = (optionItem) => {
    setQuery("");
    setSelectedItems([
        ...selectedItems,
        {
          id: optionItem[props.optionId],
          text: optionItem[props.optionLabel]
        }
      ]);
    setOpen(false);
};

const valueChangeHandler = (value) => {
   /*  props.onChange(value);*/
  };

const closeSelectedOptionHandler = (e, iid) => {
    setSelectedItems((prevItems) =>
    prevItems.filter((item) => item.id !== iid)
  );
};

function renderSelectedList() {
return (
    selectedItems.map((item) => 
    <OptionChip key={item.id} id={item.id} text={item.text} onCloseClick={closeSelectedOptionHandler}></OptionChip>
    )
);
};

    return (
    <div id={props.id} style={{ width: `${props.width + "px"}` }} className="mkt-wrapper">
        <div className="mkt-board">
            <div className="mkt-selection">
                {renderSelectedList()}
                <input type="text" 
                ref = {ref}
                placeholder={props.prompt}
                value={displayPrompt()}
                onChange={(e) => {
                    setQuery(e.target.value);
                   /* valueChangeHandler(null);*/
                }}
                onClick={toggleSourcePanel}
                onTouchEnd={toggleSourcePanel}
                />
                
                </div>
            <div className={`mkt-button ${open ? "open" : null}`}></div>
        </div>
        <div className={`mkt-source ${open ? "open" : null}`}>
            {
                filter(props.source).map((item) => (
                <div 
                key={item[props.optionId]}
                    className={`mkt-option ${props.value === item ? "selected" : null}`} 
                    onClick={() => {selectOptionHandler(item);}}
                    onTouchEnd={() => {selectOptionHandler(item);}}
                    >{item[props.optionLabel]}</div>)
                )}
        </div>
    </div>);
}

export default MultiSelekt;